var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 20 20"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v15.06a1 1 0 0 1-1.58.814L10 15.725l-4.42 3.149A1 1 0 0 1 4 18.06V3z"
  })));
};
export default SvgBookmark;